import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const DatabaseOptionContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
`;

export const DatabaseOptionContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DatabaseOptionTitle = styled.div`
  font-size: 14px;
  color: ${token('color.text', '#172B4D')};
`;
export const DatabaseOptionIcon = styled.span`
  padding-top: 4px;
`;

export const DatabaseOptionInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  font-size: 11px;
  font-weight: 400;
  color: ${token('color.text.subtlest', '#6B778C')};
`;

export const ErrorMessage = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 12px;
  padding-top: 2px;
  gap: 4px;
  color: ${token('color.text.danger', '#AE2A19')};
`;
